module.exports = __webpack_public_path__ + "img/sport-51-@1x.0af225a9.png";